import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import LinkButton from '../../../../../common/LinkButton';
import { dealStatus } from '../../../../../login/utils/Status';
import DownloadHistoricalDeals from '../../../modal/HistoricalDeals';
import DealsListDesktopView from '../ListView/Desktop';
import { common_container } from '../TopCard';
import RecentlyClosedDesktop from './Desktop';
import RecentlyClosedMobile from './Mobile';

type Props = {
    clickOnClosedDeals: () => void;
    view: 'grid' | 'list';
};

const DealsRecentlyClosed: React.FC<Props> = ({ clickOnClosedDeals, view }) => {
    const deals = useSelector((state: RootState) => state.deal.deals);

    //Filter deals by filter
    const list = useMemo(() => {
        return deals.filter((d) => d.deal.status === dealStatus.invested || d.deal.status === dealStatus.completed);
    }, [deals]);
    if (!list.length) {
        return <></>;
    }
    return (
        <div className="bg-[#20222B] py-8">
            <div className={`${common_container}`}>
                <p className="font-[WorkSans-Semibold] text-white font-semibold text-[22px] lg:text-[32px] uppercase">
                    Recently Closed
                </p>
            </div>
            {view === 'list' ? (
                <div className={`${common_container} md:block hidden`}>
                    <DealsListDesktopView list={list} isRecentList={true} />
                </div>
            ) : (
                <div className={`hidden md:block max-w-[1600px] m-auto pl-4 md:pl-6 lg:pl-16 xl:pl-20 2xl:pl-24 my-8`}>
                    <RecentlyClosedDesktop list={list} />
                </div>
            )}
            <div className="flex md:hidden">
                <RecentlyClosedMobile list={list} />
            </div>
            <div className={`flex-col lg:flex-row flex pt-4 ${common_container}`}>
                <div className="mr-10">
                    <LinkButton
                        title="View All Recently Closed Deals"
                        variant="light"
                        onClick={clickOnClosedDeals}
                        isArrow={true}
                    />
                </div>
                <DownloadHistoricalDeals />
            </div>
        </div>
    );
};

export default DealsRecentlyClosed;
